export const MOCK_ORGANS_DATA = {
  circles: [
    {
      circleId: 1600,
      code: "1600",
      name: "הקהילה היהודית",
      has_add_permission: true,
    },
    {
      circleId: 1700,
      code: "1700",
      name: "אור וחבורתו",
      has_add_permission: true,
    },
  ],
  counties: [
    {
      code: "1200",
      countyId: 1200,
      name: "מחוז עמקים",
      parent: 1600,
      has_add_permission: true,
    },
    {
      code: "1201",
      countyId: 1201,
      name: "מחוז חיפה",
      parent: 1600,
      has_add_permission: true,
    },
  ],
 nests: [
    {
      code: "650",
      name: "קרית טבעון",
      nestId: 650,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "802",
      name: "כפר תבור",
      nestId: 802,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "804",
      name: "רמת ישי",
      nestId: 804,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "805",
      name: "מגדל העמק",
      nestId: 805,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "806",
      name: "נוף הגליל",
      nestId: 806,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "807",
      name: "קן עפולה",
      nestId: 807,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "809",
      name: "טבריה",
      nestId: 809,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "1850",
      name: "בית שאן",
      nestId: 1850,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "1901",
      name: "עפולה עילית",
      nestId: 1901,
      parent: 1200,
      has_add_permission: true,
    },
    {
      code: "670",
      name: "כרמל צרפתי",
      nestId: 670,
      parent: 1201,
      has_add_permission: true,
    },
    {
      code: "671",
      name: "נווה שאנן",
      nestId: 671,
      parent: 1201,
      has_add_permission: true,
    },
  ],


  
  // הוספת הפונקציה לכאן:
  organTypeToText: (type: "circle" | "county" | "nest"): string => {
    const map = {
      circle: "מעגל", // שנה את הטקסט למה שצריך
      county: "מחוז",
      nest: "קן"
    };
    return map[type] || type;
  }
};



// WEBPACK FOOTER //
// ./src/app/or-dev/test-data.ts